import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete } from "react-icons/md";
import moment from "moment";
import { EditButton, ModalHeader, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ModalSectionTitle, ScrollableContent } from "../Styles/InputStyles";
import { getModeName, getNatureName } from "../../helpers";
import { Link } from "react-router-dom";

const ViewDetails = ({
    setIsViewExpense,
    selectedData,
    setIsEditExpense,
    setIsDeleteExpense,
    setPropId,
    filter,
    setIsEditRecurringExpense
}) => {
    const property = selectedData?.propertyList?.[0] || {};
    const asset = selectedData?.asset || {};
    const flat = selectedData?.flatList?.[0] || {};
    React.useEffect(() => {
        if (property?.id) {
            setPropId(property.id);
        }
    }, [property, setPropId]);

    const onClose = () => {
        setIsViewExpense(false);
    };

    const handleDeleteExpense = () => {
        setIsDeleteExpense(true);
        if (property?.id) {
            setPropId(property.id);
        }
    };

    const getStatusBadge = (status) => {
        const statusStyles = {
            1: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
            2: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
        };

        const statusText = {
            1: "One Time",
            2: "Monthly",
        };

        return (
            <span
                className={`px-4 py-2 rounded-full text-xs font-semibold ${statusStyles[status] || "bg-gray-100 text-gray-800"
                    }`}
            >
                {statusText[Number(status)] || "Not Assigned"}
            </span>
        );
    };

    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Expense Details</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <ProfileSection className="flex justify-between">
                <UserInfo>
                    {/* <span className="font-medium mb-0">₹{selectedData?.amount}</span> */}

                    {selectedData?.expenseTitle ?
                        <>
                            <span className="text-sm font-medium text-gray-800">{selectedData?.expenseTitle}</span>
                            <span className="text-xs font-normal text-gray-500">{selectedData?.name}</span>
                        </>
                        :
                        <span className="text-sm font-medium text-gray-800">{selectedData?.name}</span>
                    }

                </UserInfo>
                <div className="flex gap-2">
                    {filter !== "RE" &&
                        <span>{getStatusBadge(selectedData?.repetitionType)}</span>}
                    {!selectedData?.bankRefNum &&
                        <MdDelete
                            size={20}
                            className="text-rose-500 cursor-pointer mt-1"
                            title="Delete Expense"
                            onClick={handleDeleteExpense}
                        />}
                </div>
            </ProfileSection>
            <Content>
                <ScrollableContent className="max-h-[calc(100dvh-200px)]">
                    <Wrapper>

                        <BtnWrapper>
                            <ModalSectionTitle>Transaction Details</ModalSectionTitle>
                            {filter !== "UM" && !selectedData?.bankRefNum &&
                                <EditButton
                                    title="Edit Basic Detail"
                                    onClick={() => {
                                        setIsViewExpense(false);
                                        if (filter === "RE") {
                                            setIsEditRecurringExpense(true);
                                        } else {
                                            setIsEditExpense(true);
                                        }
                                    }}
                                >
                                    Edit
                                </EditButton>}
                        </BtnWrapper>

                        <ModalSection>
                            <ModalRow>
                                <FlexCol className="mb-0">
                                    <ModalRowLabel>Amount Paid</ModalRowLabel>
                                    <ModalRowValue>₹{selectedData?.amount}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Payment Mode</ModalRowLabel>
                                    <ModalRowValue>
                                        {(filter !== "RE" && filter !== "UM") ? getModeName(selectedData?.paymentMethod) : "--"}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <ModalRow>

                                <FlexCol className="mb-0">
                                    <ModalRowLabel>{"Due Date"}</ModalRowLabel>
                                    <ModalRowValue>
                                        {selectedData?.dueDate ? moment(selectedData?.dueDate).format("DD, MMM YYYY") : '-'}
                                    </ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>{"Paid Date"}</ModalRowLabel>
                                    <ModalRowValue>
                                        {selectedData?.paidDate ? moment(selectedData?.paidDate).format("DD MMM YYYY, HH:mm") : '-'}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <ModalRow>
                                <FlexCol className="mb-0">
                                    <ModalRowLabel>Paid By</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.paidByName}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Paid To</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.paidToName}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <ModalRow>

                                <FlexCol>
                                    <ModalRowLabel>Nature of Expense</ModalRowLabel>
                                    <ModalRowValue>
                                        {getNatureName(selectedData?.expenseNature) || "--"}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            {selectedData?.bankRefNum &&
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>UTR</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.bankRefNum}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                            }
                        </ModalSection>
                        {(property?.name || selectedData?.description || selectedData?.supportDoc || asset?.name) &&
                            <>
                                <BtnWrapper>
                                    <ModalSectionTitle>Expense Details</ModalSectionTitle>
                                </BtnWrapper>
                                <ModalSection>
                                    {property?.name &&
                                        <ModalRow className="mb-3">
                                            <FlexCol>
                                                <ModalRowLabel>Property Name</ModalRowLabel>
                                                <ModalRowValue> {`${property?.name}`}
                                                </ModalRowValue>
                                            </FlexCol>
                                            {flat?.name &&
                                                <FlexCol>
                                                    <ModalRowLabel>Flat Name</ModalRowLabel>
                                                    <ModalRowValue>
                                                        {`Flat ${flat?.name}`}
                                                    </ModalRowValue>
                                                </FlexCol>
                                            }
                                        </ModalRow>
                                    }
                                    {asset?.name &&
                                        <ModalRow className="mb-3">
                                            <FlexCol>
                                                <ModalRowLabel>Asset</ModalRowLabel>
                                                <ModalRowValue> {`${asset?.name}`}
                                                </ModalRowValue>
                                            </FlexCol>
                                            <FlexCol>
                                                <ModalRowLabel>Vehicle Number</ModalRowLabel>
                                                <ModalRowValue>
                                                    {`${asset?.vehicleNum}`}
                                                </ModalRowValue>
                                            </FlexCol>

                                        </ModalRow>
                                    }
                                    {selectedData?.description &&
                                        <div>
                                            <FlexCol>
                                                <ModalRowLabel>Description</ModalRowLabel>
                                                <ModalRowValue>{selectedData?.description}</ModalRowValue>
                                            </FlexCol>
                                        </div>}
                                    <div className="flex justify-end">
                                        <FlexCol>
                                            <ModalRowValue className="text-blue-500 underline">
                                                <Link
                                                    to={selectedData?.supportDoc}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {selectedData?.supportDoc?.split("/").pop()}
                                                </Link>
                                            </ModalRowValue>
                                        </FlexCol>
                                    </div>
                                </ModalSection>
                            </>
                        }
                    </Wrapper>
                </ScrollableContent>
            </Content>
        </Container>
    );
};

const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
//const ModalSection = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
// const ModalSectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
//const ModalRow = tw.div`grid grid-cols-2 py-1 md:p-1`;
//const ModalRowLabel = tw.label`text-sm text-gray-400 font-normal`;
//const ModalRowValue = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
// const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`;
export default ViewDetails;